module.exports = __webpack_public_path__ + "static/noel-leeming-d2577ef81139171afa98f19b6ed57d05.jpg";